module.exports = __webpack_public_path__ + "img/tips3list4img19120304.9a406f7e.jpg";